import { useState } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Unstable_Grid2";
import { Link, Box, Tab, Tabs } from "@mui/material";
import { ZoomIn } from "@mui/icons-material";
import { TabPanel } from "../tabPanel/TabPanel";
import mediaPlaceholderImage from "../../../assets/media-placeholder.jpg";
import { initLocalization } from "../../../utils/helpers";
import { poolMediaStrings } from "./locale";
import { CREATIVES_MEDIA_DOMAIN } from "../../../constants";
import "./style.scss";

const createMedia = (type, details) => {
  const creativeDetails = {
    ...details,
    imgAlt: (
      details.title ||
      details?.campaignVm?.campaignTitle ||
      details?.creativeText
    )?.slice(0, 100),
    rawlocation: details.rawLocation,
    rawmediaTypeName: details.rawMediaTypeName,
  };

  return (
    <Grid paddingY="2.6rem" className="pool-media-wrapper">
      {creativeDetails?.[`${type}mediaTypeName`].length === 0 && (
        <img
          src={mediaPlaceholderImage}
          alt={creativeDetails.imgAlt}
          className="pool-media-wrapper__media-placeholder"
        />
      )}
      {creativeDetails?.[`${type}mediaTypeName`] === "image" && (
        <img
          src={creativeDetails[`${type}location`]}
          alt={creativeDetails.imgAlt}
          className="pool-media-wrapper__media-image"
        />
      )}
      {creativeDetails?.[`${type}mediaTypeName`] === "video" && (
        <video className="pool-media-wrapper__media-video" controls muted>
          <source src={creativeDetails[`${type}location`]} />
        </video>
      )}
      {creativeDetails?.[`${type}mediaTypeName`]?.toLowerCase() === "html5" && (
        <iframe
          className="pool-media-wrapper__media-iframe"
          title={creativeDetails?.id}
          src={
            creativeDetails?.[`${type}location`]?.split(
              CREATIVES_MEDIA_DOMAIN,
            )?.[1]
          }
        />
      )}
      {creativeDetails?.[`${type}mediaTypeName`].length > 0 && (
        <Link
          className="zoom-creative"
          href={creativeDetails[`${type}location`]}
          target="_blank"
        >
          <ZoomIn fontSize="inherit" />
        </Link>
      )}
    </Grid>
  );
};

export const PoolMedia = ({ creativeDetails }) => {
  initLocalization(poolMediaStrings);

  const [selectedTab, setSelectedTab] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      {creativeDetails?.rawMediaTypeName ? (
        <>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={selectedTab}
              onChange={handleChangeTab}
              aria-label="media tabs"
            >
              <Tab
                label={poolMediaStrings.preview}
                id="tab-0"
                aria-controls="tabpanel-0"
              />
              <Tab
                label={poolMediaStrings.detail}
                id="tab-1"
                aria-controls="tabpanel-1"
              />
            </Tabs>
          </Box>
          <TabPanel
            className="pool-media-tab-panel"
            value={selectedTab}
            index={0}
          >
            {createMedia("", creativeDetails)}
          </TabPanel>
          <TabPanel
            className="pool-media-tab-panel"
            value={selectedTab}
            index={1}
          >
            {createMedia("raw", creativeDetails)}
          </TabPanel>
        </>
      ) : (
        createMedia("", creativeDetails)
      )}
    </>
  );
};

PoolMedia.propTypes = {
  creativeDetails: PropTypes.object.isRequired,
};
